import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useUpdateDeviceSettings } from 'src/hooks/device';
import DeviceStatusForm from './DeviceStatusForm';

const DeviceStatusModal = ({
  open,
  title,
  description,
  deviceId,
  initialStatus = '',
  initialTags = [],
  onClose,
  onSaved,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const updateDeviceSettingsMutation = useUpdateDeviceSettings();

  const handleSubmit = async ({ status, notes, tags = [] }) => {
    const tagIds = tags.filter(tag => tag.id).map(tag => tag.id);
    const tagNames = tags
      .filter(tag => !tag.id)
      .map(tag => (tag.name || '').trim())
      .filter(Boolean);

    try {
      if (!deviceId) {
        return;
      }

      await updateDeviceSettingsMutation.mutateAsync({
        deviceId,
        status,
        notes: notes.trim(),
        tagIds,
        tagNames,
      });

      enqueueSnackbar('Device status updated successfully.', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      onSaved?.();
      onClose();
    } catch (_error) {
      enqueueSnackbar('Something went wrong.', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { backgroundColor: '#3F3F3F' } }}>
      <DialogTitle>{title || 'Update Device Status'}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: '#DDDDDD', mt: 1 }}>
          {description || 'Update the selected device.'}
        </Typography>
        <DeviceStatusForm
          initialStatus={initialStatus}
          initialTags={initialTags}
          isSaving={updateDeviceSettingsMutation.isLoading}
          onCancel={onClose}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

DeviceStatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  deviceId: PropTypes.number,
  initialStatus: PropTypes.string,
  initialTags: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func,
};

export default DeviceStatusModal;
